<div class="modal fade" [id]="modalId" role="dialog">
  <div class="modal-dialog " [ngClass]="{'modal-lg': modalSize === 'lg', 'modal-md': modalSize !== 'lg' }" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="title" id="addAgentModalLabel">
          {{modalTitle}}
        </h4>
      </div>
      <ng-content></ng-content>
    </div>
  </div>
</div>
